/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Patient } from '../../models/patient';

export interface MyPatientControllerFindByNames$Params {
  firstname?: string;
  lastname: string;
}

export function myPatientControllerFindByNames(http: HttpClient, rootUrl: string, params: MyPatientControllerFindByNames$Params, context?: HttpContext): Observable<StrictHttpResponse<Patient>> {
  const rb = new RequestBuilder(rootUrl, myPatientControllerFindByNames.PATH, 'get');
  if (params) {
    rb.query('firstname', params.firstname, {});
    rb.query('lastname', params.lastname, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Patient>;
    })
  );
}

myPatientControllerFindByNames.PATH = '/api/my-patients/by-names';
